// extracted by mini-css-extract-plugin
export var columnList = "_cr-0";